<template>
    <div class="freight">
      <div class="jingxyj">
        <div class="delivery-header">
          <div class="titleBox">
            <div
              class="title"
              :class="{ background: isBackground(index) , backgroundER: isBackground(index) && index==0 , backgroundBaiER: index==0 }"
              v-for="(item, index) in titleList"
              :key="index"
              @click="handleClickTitle(index,item.url)"
            >
              {{ item.tit }}
            </div>
          </div>
        </div>
        <div class="delivery-show" v-if="marketIndex == 0">
          <div class="delivery-main">
            <div class="delivery-main-box youjiantou">
              <img src="@/assets/images/hpcopy/定位.png" alt="" />
              <div class="address">
                <div>起运港</div>
                <el-select v-model="searchQuery1JXYJ" clearable  filterable placeholder="请选择">
                  <el-option
                    v-for="item in qiYGTitleList"
                    :key="item.id"
                    :label="item.name_cn+'-'+item.name_en"
                    :value="item.id"
                    v-show="item.display_range==0 || item.display_range==1"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="youbian">
                <img src="../../assets/images/Group 92.png" />
              </div>
            </div>
  
            <div class="delivery-main-box">
              <img src="@/assets/images/hpcopy/定位.png" alt="" />
              <div class="address">
                <div>目的港</div>
                <el-select  
                v-model="searchQuery2JXYJ" 
                clearable  
                filterable 
                placeholder="请选择"
                remote
                reserve-keyword
                :remote-method="mdgremoteMethod"
                :loading="mdgloading">
                   <!-- @tab-click="handleClick" -->
                  <el-tabs class="mudig" v-model="mdgActiveName">
                    <el-tab-pane
                      :key="index"
                      v-for="(item,index) in muDgList"
                      :label="item.route_name"
                      :name="item.route_name"
                    >
                      <el-option-group
                        v-for="(it,idx) in item.tag_arr"
                        :key="idx"
                        :label="it.tag_name"
                        :value="it.tag_id"
                        class="mdglist">
                        <el-option
                          v-for="(at,adx) in it.port_arr"
                          :key="adx"
                          :label="at.port_name+'-'+at.name_en"
                          :value="at.port_id">
                        </el-option>
                      </el-option-group>
                    </el-tab-pane>
                  </el-tabs>
                </el-select>
              </div>
            </div>
            <div class="delivery-main-box">
              <img src="@/assets/images/hpcopy/箱型.png" alt="" />
              <div class="address">
                <div>箱型</div>
                <el-select 
                :multiple-limit="3"
                multiple
                collapse-tags
                class="xiangxing"
                clearable
                v-model="searchQuery3JXYJ" 
                placeholder="请选择">
                <el-option
                  v-for="item in boxTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
              </div>
            </div>
            <div class="delivery-main-box">
              <img src="@/assets/images/hpcopy/日期.png" alt="" />
              <div class="address">
                <div>开航起止日期</div>
                <el-date-picker
                  :picker-options="pickerOptions"
                  value-format='yyyy-MM-dd'
                  prefix-icon="null"
                  class="picker"
                  v-model="DateValue1"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </div>
  
            <div class="search"  @click="searchList('JXYJ')">
              <i class="el-icon-search"></i>搜索
            </div>
          </div>
          <div v-if="historyPortList.length>0" class="delivery-foot">
            <div class="jilu">历史记录</div>
            <div class="delivery-history-box">
              <div class="delivery-history"
              v-for="(item,index) in historyPortList"
              :key="index"
              @click="historySearch('JXYJ',item)"
              >
              {{item.state_port_name}}-{{item.end_port_name}}
            </div>
            </div>
          </div>
        </div>
        <div class="delivery-show" v-if="marketIndex == 1">
          <div class="delivery-main">
            <div class="delivery-main-box youjiantou">
              <img src="@/assets/images/hpcopy/定位.png" alt="" />
              <div class="address">
                <div>起运港</div>
                <el-select v-model="searchQuery1XCSC" clearable  filterable placeholder="请选择">
                  <el-option
                    v-for="item in qiYGTitleList"
                    :key="item.id"
                    :label="item.name_cn+'-'+item.name_en"
                    :value="item.id"
                    v-show="item.display_range==0 || item.display_range==1"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="youbian">
                <img src="../../assets/images/Group 92.png" />
              </div>
            </div>
  
            <div class="delivery-main-box">
              <img src="@/assets/images/hpcopy/定位.png" alt="" />
              <div class="address">
                <div>目的港</div>
                <el-select  v-model="searchQuery2XCSC" clearable  filterable placeholder="请选择"
                  remote
                  reserve-keyword
                  :remote-method="mdgremoteMethod"
                  :loading="mdgloading">
                   <!-- @tab-click="handleClick" -->
                  <el-tabs class="mudig" v-model="mdgActiveName" filterable>
                    <el-tab-pane
                      :key="index"
                      v-for="(item,index) in muDgList"
                      :label="item.route_name"
                      :name="item.route_name"
                    >
                      <el-option-group
                        v-for="(it,idx) in item.tag_arr"
                        :key="idx"
                        :label="it.tag_name"
                        :value="it.tag_id"
                        class="mdglist">
                        <el-option
                          v-for="(at,adx) in it.port_arr"
                          :key="adx"
                          :label="at.port_name+'-'+at.name_en"
                          :value="at.port_id">
                        </el-option>
                      </el-option-group>
                    </el-tab-pane>
                  </el-tabs>
                </el-select>
              </div>
            </div>
            <div class="delivery-main-box">
              <img src="@/assets/images/hpcopy/箱型.png" alt="" />
              <div class="address">
                <div>箱型</div>
                <el-select 
                :multiple-limit="3"
                multiple
                collapse-tags
                class="xiangxing"
                clearable
                v-model="searchQuery3XCSC" 
                placeholder="请选择">
                <el-option
                  v-for="item in boxTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
              </div>
            </div>
            <div class="delivery-main-box">
              <img src="@/assets/images/hpcopy/日期.png" alt="" />
              <div class="address">
                <div>开航起止日期</div>
                <!-- <input type="date" placeholder="开始日期"> -->
                <el-date-picker
                  value-format='yyyy-MM-dd'
                  :picker-options="pickerOptions"
                  prefix-icon="null"
                  class="picker"
                  v-model="DateValue2"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </div>
  
            <div class="search" @click="searchList('XCSC')">
              <i class="el-icon-search"></i>搜索
            </div>
          </div>
          <div v-if="historyPortList.length>0" class="delivery-foot">
          <div class="jilu">历史记录</div>
          <div class="delivery-history-box">
            <div class="delivery-history"
            v-for="(item,index) in historyPortList"
            :key="index"
            @click="historySearch('XCSC',item)"
            >
            {{item.state_port_name}}-{{item.end_port_name}}
          </div>
          </div>
        </div>
        </div>
        <div class="delivery-show" v-if="marketIndex == 2">
          <div class="delivery-main">
            <div class="delivery-main-box youjiantou">
              <img src="@/assets/images/hpcopy/定位.png" alt="" />
              <div class="address">
                <div>起运港</div>
                <el-select v-model="searchQuery1CD" clearable  filterable placeholder="请选择">
                  <el-option
                    v-for="item in qiYGTitleList"
                    :key="item.id"
                    :label="item.name_cn+'-'+item.name_en"
                    :value="item.id"
                    v-show="item.display_range==0 || item.display_range==2"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="youbian youbianvv">
                <img src="../../assets/images/Group 92.png" />
              </div>
              <div class="switch jiantou">
                <div
                  :class="{ switchBackground: isSwitchQY(1) }"
                  @click="handleSwitchQY(1)"
                >
                  CY
                </div>
                <div
                  :class="{ switchBackground: isSwitchQY(2) }"
                  @click="handleSwitchQY(2)"
                >
                  SD
                </div>
              </div>
            </div>
  
            <div class="delivery-main-box">
              <img src="@/assets/images/hpcopy/定位.png" alt="" />
              <div class="address">
                <div>目的港</div>
                <el-select  v-model="searchQuery2CD" clearable  filterable placeholder="请选择"
                  remote
                  reserve-keyword
                  :remote-method="mdgremoteMethod"
                  :loading="mdgloading">
                   <!-- @tab-click="handleClick" -->
                  <el-tabs class="mudig" v-model="mdgActiveName">
                    <el-tab-pane
                      :key="index"
                      v-for="(item,index) in muDgList"
                      :label="item.route_name"
                      :name="item.route_name"
                    >
                      <el-option-group
                        v-for="(it,idx) in item.tag_arr"
                        :key="idx"
                        :label="it.tag_name"
                        :value="it.tag_id"
                        class="mdglist">
                        <el-option
                          v-for="(at,adx) in it.port_arr"
                          :key="adx"
                          :label="at.port_name+'-'+at.name_en"
                          :value="at.port_id">
                        </el-option>
                      </el-option-group>
                    </el-tab-pane>
                  </el-tabs>
                </el-select>
              </div>
              <div class="switch">
                <div
                  :class="{ switchBackground: isSwitchMD(1) }"
                  @click="handleSwitchMD(1)"
                >
                  CY
                </div>
                <div
                  :class="{ switchBackground: isSwitchMD(2) }"
                  @click="handleSwitchMD(2)"
                >
                  SD
                </div>
              </div>
            </div>
            <div class="delivery-main-box">
              <img src="@/assets/images/hpcopy/箱型.png" alt="" />
              <div class="address">
                <div>箱型</div>
                <el-select 
                :multiple-limit="3"
                multiple
                collapse-tags
                class="xiangxing"
                clearable
                v-model="searchQuery3CD" 
                placeholder="请选择">
                <el-option
                  v-for="item in boxTypeListCd"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
              </div>
            </div>
            <div class="delivery-main-box">
              <img src="@/assets/images/hpcopy/日期.png" alt="" />
              <div class="address">
                <div>开航起止日期</div>
                <!-- <input type="date" placeholder="开始日期"> -->
                <el-date-picker
                  value-format='yyyy-MM-dd'
                  :picker-options="pickerOptions"
                  prefix-icon="null"
                  class="picker"
                  v-model="DateValue3"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </div>
  
            <div class="search" @click="searchList('CD')">
              <i class="el-icon-search"></i>搜索
            </div>
          </div>
          <div v-if="historyPortList.length>0" class="delivery-foot">
          <div class="jilu">历史记录</div>
          <div class="delivery-history-box">
            <div class="delivery-history"
            v-for="(item,index) in historyPortList"
            :key="index"
            @click="historySearch('CD',item)"
            >
            {{item.state_port_name}}-{{item.end_port_name}}
          </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { 
    basePortValidList,
    destinationPortRouteTypeValidList,
    baseCasesGaugeTypeValidList,
    historyPort
  } from "@/api/api";
  export default {
    data() {
      return {
        mdgloading:false,
        // 运货标签
        titleList: [
            {
              tit:"精选运价",
              url:'/SelectedFreightRates'
            },{
              tit:"现舱市场",
              url:'/Market'
            },{
              tit:"船东SPOT",
              url:'/ShipSPOT'
            },
        ],
        marketIndex: sessionStorage.getItem('lineIndex') - 1 || "0",
        //   默认第一个有背景颜色
        highlightBackground: 0,
        // 默认第一个是开的
        highlightSwitchQY: 1,
        highlightSwitchMD: 1,
        // 起运港内容
        qiYGValue: "",
        // 起运港列表
        qiYGTitleList: [],
        muDgList:[],
        boxTypeList: [],
        // 发货港口
        searchQuery1JXYJ: "",
        searchQuery1XCSC: "",
        searchQuery1CD: "",
        searchQuery1MJDM: "",
  
        // 收货港口
        searchQuery2JXYJ: "",
        searchQuery2XCSC: "",
        searchQuery2CD: "",
        searchQuery2MJDM: "",
  
        // 箱型
        searchQuery3JXYJ: [],
        searchQuery3XCSC: [],
        searchQuery3CD: [],
        searchQuery3MJDM: [],
        boxTypeListCd:[
          {
            "id": 17,
            "name": "20GP"
          },
          {
            "id": 18,
            "name": "40GP"
          },
          {
            "id": 19,
            "name": "40HQ"
          }
        ],
        // 国家
        countryText: "",
        // 邮编
        zipCodeText: "",
  
        // 日期
        DateValue1: "",
        DateValue2: "",
        DateValue3: "",
  
        // 进出口单选框
        radio: "1",
        // 历史记录
        historyPortList:[],
        activeName:'',
        mdgActiveName:'',
        pickerMinDate: null,
        pickerMaxDate: null,
        daySanshi: 30 * 24 * 3600 * 1000,
        pickerOptions: {
            onPick: ({  minDate }) => {
            if (minDate && this.pickerMinDate) {
              this.pickerMinDate = null;
            } else if (minDate) {
              this.pickerMinDate = minDate.getTime();
            }
          },
          disabledDate: (time) => {
            if (this.pickerMinDate) {
              return (time.getTime() - 2 * 3600 * 1000 * 24) < Date.now() - 8.64e7 || (time.getTime() > (this.pickerMinDate + this.daySanshi)) || (time.getTime() < (this.pickerMinDate - this.daySanshi));
            }
            //  return false;
            return (time.getTime() - 2 * 3600 * 1000 * 24) < Date.now() - 8.64e7
          }
        },
      };
    },
    methods: {
      // 点击送货标签
      handleClickTitle(index,url) {
        this.highlightBackground = index;
        this.marketIndex = index;
        if( this.$route.path != url ){
            if(url == '/SelectedFreightRates'){
            sessionStorage.setItem('lineIndex',1)
            }else if(url == "/Market"){
                sessionStorage.setItem('lineIndex',2)
            }else if(url == "/ShipSPOT"){
                sessionStorage.setItem('lineIndex',3)
            }
            this.$router.push(url)
        }
      },
      // 触发背景颜色
      isBackground(index) {
        // return this.highlightBackground === index;
        let gao = sessionStorage.getItem('lineIndex')
          return Number(gao)-1 === Number(index);
      },
      // 点击开关
      handleSwitchQY(val) {
        this.highlightSwitchQY = val;
      },
      handleSwitchMD(val) {
        this.highlightSwitchMD = val;
      },
      // 点击开关--显示样式
      isSwitchQY(val) {
        return this.highlightSwitchQY === val;
      },
      isSwitchMD(val) {
        return this.highlightSwitchMD === val;
      },
      // 目的港切换标签内容
      // handleClick(tab, event) {
      // },
      // 国家
      countryHandleCommand(command) {
        this.countryText = command;
      },
      // 邮编
      zipCodeHandleCommand(command) {
        this.zipCodeText = command;
      },
      // 获取数据列表
      async getQygList() {
        // 起运港列表
        let basePortParams = {
          page_no: 1,
          page_size: 50,
          keyword: '',
        };
        const basePortRes = await basePortValidList(basePortParams);
        if (basePortRes.code==1) {
          this.qiYGTitleList=basePortRes.data.lists
        }
      },
      async getMdgList(e) {
        this.mdgloading = true;
        if(e==undefined){
          e=''
        }
        // 目的港列表
        const res = await destinationPortRouteTypeValidList({
            keyword:e
          });
        if (res.code==1) {
          this.muDgList=res.data
          if(res.data.length>0){
            this.mdgActiveName=res.data[0].route_name
          }
          this.mdgloading = false
          // mdgloading:false,
        }
      },
      mdgremoteMethod(query){
        if (query !== '') {
          setTimeout(async () => {
            this.getMdgList(query)
          }, 200);
        } else {
          this.getMdgList();
        }
      },
      // 箱型
      async getBoxTypeList() {
        // 目的港列表
        const res = await baseCasesGaugeTypeValidList();
        if (res.code==1) {
          this.boxTypeList=res.data
        }
      },
      searchList(e){
        let statePortForm=''
        let endPortForm=''
        

        if(e=='JXYJ'){
          sessionStorage.setItem("lineIndex", 1);
          for (let i = 0; i < this.qiYGTitleList.length; i++) {
              if(this.qiYGTitleList[i].id ==this.searchQuery1JXYJ){
                statePortForm = this.qiYGTitleList[i].name_cn+'-'+this.qiYGTitleList[i].name_en
              }
          }

          for (let i = 0; i < this.muDgList.length; i++) {
            for (let j = 0; j < this.muDgList[i].tag_arr.length; j++) {
              for (let k = 0; k < this.muDgList[i].tag_arr[j].port_arr.length; k++) {
                if(this.muDgList[i].tag_arr[j].port_arr[k].port_id==this.searchQuery2JXYJ){
                  endPortForm = this.muDgList[i].tag_arr[j].port_arr[k].port_name+'-'+this.muDgList[i].tag_arr[j].port_arr[k].name_en
                }
              }
            }
          }
          if (this.searchQuery1JXYJ=='') {
            this.$message({
              type:'error',
              message:'请选择起运港'
            })
          }else if(this.searchQuery2JXYJ==''){
            this.$message({
              type:'error',
              message:'请选择目的港'
            })
          }else if(this.searchQuery3JXYJ.length==0){
            this.$message({
              type:'error',
              message:'请选择箱型'
            })
          }else{
            let param = {
              qi:this.searchQuery1JXYJ,
              statePortForm:statePortForm,
              endPortForm:endPortForm,
              mu:this.searchQuery2JXYJ,
              boxtype:this.searchQuery3JXYJ,
              createTime:this.DateValue1[0],
              endTime:this.DateValue1[1]
            }
            this.$router.push({
              name:'SearchResults',
              params:param
            })
          }
          
        }else if(e=='XCSC'){
          sessionStorage.setItem("lineIndex", 2);
          for (let i = 0; i < this.qiYGTitleList.length; i++) {
              if(this.qiYGTitleList[i].id ==this.searchQuery1XCSC){
                statePortForm = this.qiYGTitleList[i].name_cn+'-'+this.qiYGTitleList[i].name_en
              }
          }

          for (let i = 0; i < this.muDgList.length; i++) {
            for (let j = 0; j < this.muDgList[i].tag_arr.length; j++) {
              for (let k = 0; k < this.muDgList[i].tag_arr[j].port_arr.length; k++) {
                if(this.muDgList[i].tag_arr[j].port_arr[k].port_id==this.searchQuery2XCSC){
                  endPortForm = this.muDgList[i].tag_arr[j].port_arr[k].port_name+'-'+this.muDgList[i].tag_arr[j].port_arr[k].name_en
                }
              }
            }
          }

          if (this.searchQuery1XCSC=='') {
            this.$message({
              type:'error',
              message:'请选择起运港'
            })
          }else if(this.searchQuery2XCSC==''){
            this.$message({
              type:'error',
              message:'请选择目的港'
            })
          }else if(this.searchQuery3XCSC.length==0){
            this.$message({
              type:'error',
              message:'请选择箱型'
            })
          }else {
            let param = {
              qi:this.searchQuery1XCSC,
              mu:this.searchQuery2XCSC,
              statePortForm:statePortForm,
              endPortForm:endPortForm,
              boxtype:this.searchQuery3XCSC,
              createTime:this.DateValue2[0],
              endTime:this.DateValue2[1]
            }
            this.$router.push({
              name:'MarketSearchResults',
              params:param
            })
          }
        }else if(e=='CD'){
          sessionStorage.setItem("lineIndex", 3);
          let qygName=''
          let mdgName=''
          for (let i = 0; i < this.qiYGTitleList.length; i++) {
              if(this.qiYGTitleList[i].id ==this.searchQuery1CD){
                statePortForm = this.qiYGTitleList[i]
                qygName = this.qiYGTitleList[i].name_cn+'-'+this.qiYGTitleList[i].name_en
              }
          }

          for (let i = 0; i < this.muDgList.length; i++) {
            for (let j = 0; j < this.muDgList[i].tag_arr.length; j++) {
              for (let k = 0; k < this.muDgList[i].tag_arr[j].port_arr.length; k++) {
                if(this.muDgList[i].tag_arr[j].port_arr[k].port_id==this.searchQuery2CD){
                  endPortForm = this.muDgList[i].tag_arr[j].port_arr[k]
                  mdgName = this.muDgList[i].tag_arr[j].port_arr[k].port_name+'-'+this.muDgList[i].tag_arr[j].port_arr[k].name_en
                }
              }
            }
          }

          if (this.searchQuery1CD=='') {
            this.$message({
              type:'error',
              message:'请选择起运港'
            })
          }else if(this.searchQuery2CD==''){
            this.$message({
              type:'error',
              message:'请选择目的港'
            })
          }else if(this.searchQuery3CD.length==0){
            this.$message({
              type:'error',
              message:'请选择箱型'
            })
          }else {
            let param = {
              statePortForm:statePortForm,
              endPortForm:endPortForm,
              qygName:qygName,
              mdgName:mdgName,
              qi:this.searchQuery1CD,
              mu:this.searchQuery2CD,
              boxtype:this.searchQuery3CD,
              createTime:this.DateValue3[0],
              endTime:this.DateValue3[1]
            }
            this.$router.push({
              name:'ShipSPOTSearchResults',
              params:param
            })
          }
        }
      },
      async getHistoryPort(){
        // this.mjdmForm.port_id=''
        // if(this.mjdmForm.end_city_id!=''){
          const res = await historyPort({
            token:localStorage.getItem('token')
          });
          if (res.code==1) {
            this.historyPortList=res.data
          }
        
      },
      historySearch(activeName,res){
        if(activeName=='JXYJ'){
          this.searchQuery1JXYJ=res.state_port_id
          this.searchQuery2JXYJ=res.end_port_id
        }else if(activeName=='XCSC'){
          this.searchQuery1XCSC=res.state_port_id
          this.searchQuery2XCSC=res.end_port_id
        }else if(activeName=='CD'){
          this.searchQuery1CD=res.state_port_id
          this.searchQuery2CD=res.end_port_id
        }
      },
      // 处理时间
      changeDate(){
      var date = new Date();
          var year = date.getFullYear().toString();
          var currentYear = date.getFullYear().toString();
          var month = (date.getMonth() + 1).toString();
          var day = (date.getDate()+2).toString();
          var sanshiyi = ['1','3','5','7','8','10','12']
          var sanshi = ['4','6','9','11']
          var ershiba = '2'

          if(sanshiyi.includes(month)){
            if(month==12){
              if(day>31){
                day = Number(day)-31
                month = Number(month)-11
                year = Number(year)+1
              }
            }
            if(day>31){
              day = Number(day)-31
              month = Number(month)+1
            }
          }else if(sanshi.includes(month)){
            if(day>30){
              day = Number(day)-30
              month = Number(month)+1
            }
          }else if(month==ershiba){
            let run = 28
            if(year %4 == 0 && year %100 != 0 && year % 400 == 0){
              run = 29
            }
            if(day>run){
              day = Number(day)-Number(run)
              month = Number(month)+1
            }
          }
          var currentMonth = String(month);
          var currentDay = String(Number(day)+30);

          if(sanshiyi.includes(currentMonth)){
            if(currentMonth==12){
              if(currentDay>31){
                currentDay = Number(currentDay)-31
                currentMonth = Number(currentMonth)-11
                currentYear = Number(currentYear)+1
              }
            }
            if(currentDay>31){
              currentDay = Number(currentDay)-31
              currentMonth = Number(currentMonth)+1
            }
          }else if(sanshi.includes(currentMonth)){
            if(currentDay>30){
              currentDay = Number(currentDay)-30
              currentMonth = Number(currentMonth)+1
            }
          }else if(currentMonth==ershiba){
            let run = 28
            if(year %4 == 0 && year %100 != 0 && year % 400 == 0){
              run = 29
            }
            if(currentDay>run){
              currentDay = Number(currentDay)-Number(currentDay)
              currentMonth = Number(currentMonth)+1
            }
          }

          // 对月份和日期进行补零
          month = month <10 ? '0' + month : month;
          currentMonth = currentMonth <10 ? '0' + currentMonth : currentMonth;
          day = day < 10 ? '0' + day : day;
          currentDay = currentDay < 10 ? '0' + currentDay : currentDay;
          
          var currentDate = year + '-' + month + '-' + day ;
          var currentDateER = currentYear + '-' + currentMonth + '-' + currentDay;

      this.DateValue1 = [currentDate, currentDateER]
      this.DateValue2 = [currentDate, currentDateER]
      this.DateValue3 = [currentDate, currentDateER]
    }
    },
    mounted() {
      this.getQygList();
      this.getMdgList();
      this.getBoxTypeList();

      // 查询历史记录
      this.getHistoryPort()
      
      this.changeDate()    
    },
  };
  </script>
  
  <style lang="scss" scoped>
  div {
    display: inline-block;
  }
  .freight{
    width: 1200px;
  }
  .jingxyj {
    // height: 320px;
    // background: #fff;
    // box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
    // border-radius: 12px 12px 12px 12px;
    // border: 1px solid #e4e6e8;
    // margin-bottom: 20px;
    // padding-bottom: 20px;
  
    // padding: 24px;
    text-align: left;
    box-sizing: border-box;
  
    .huoquyj {
      width: 100%;
      text-align: right;
      margin: 14px 0;
    }
  }
  
  
  .titleBox {
    .title {
      // 鼠标样式
      cursor: pointer;
      width: 181px;
      height: 54px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #43597B;
      line-height: 54px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      background-image:url('@/assets/images/hpcopy/cardBj.png');	
      background-repeat: no-repeat;
      background-size:100% 100%;
    }
      .background {
      // background: #0073f5;
      // color: #ffffff !important;
      background-image:url('@/assets/images/hpcopy/cardBjHei.png');	
      background-repeat: no-repeat;
      background-size:100% 100%;
      color: #ffffff !important;
      font-size: 20px;
    }

    .backgroundBaiER{
      background-image:url('@/assets/images/hpcopy/cardBjYi.png');	
    }
    
    .backgroundER{
      background-image:url('@/assets/images/hpcopy/cardBjYiHei.png');	
      background-repeat: no-repeat;
      background-size:100% 100%;
      color: #ffffff !important;
      font-size: 20px;
    }
  }
  
  .delivery-main {
    // width: 1152px;
    // height: 72px;
    background: #f9f9f9;
    border-radius: 8px 8px 8px 8px;
    margin-top: 20px;
    box-sizing: border-box;
    padding: 14px 8px 14px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .delivery-main-box {
      border-right: 1px solid #ddd;
      padding-right: 8px;
      height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:nth-child(-n + 2) {
        width: 300px;
      }
      &:nth-child(n + 2) {
        margin-left: 8px;
      }
      &:nth-child(3) {
        width: 200px;
        input {
          width: 130px;
        }
      }
      &:nth-child(4) {
        border: 0;
        width: 220px;
      }
      .dateSpan {
        margin-right: 12px;
      }
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
      .address {
        width: 304px;
        // div:first-child{
        //   color: #666;
        // }
        div {
          display: block;
          height: 20px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        input {
          width: 100%;
          border: none;
          outline: none;
          background: #f9f9f9;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        input {
          color: #333;
          margin-top: 4px;
        }
        input::placeholder {
          color: #ccc;
        }
        .el-icon-date:before {
          content: "";
        }
        .el-input {
          display: inline-block;
          width: 80px;
        }
        .el-input--prefix .el-input__inner {
          padding-left: 0;
          padding-right: 0;
          width: 80px;
          height: 20px;
          font-size: 14px;
          display: inline-block;
        }
  
        :deep(.el-select){
          input{
            background: #f9f9f9;
            border:0;
            padding: 0;
          }
        }
      }
  
      // 选择开关
      .switch {
        cursor: pointer;
        width: 100px;
        height: 34px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        box-sizing: border-box;
        padding: 4px;
        display: flex;
        div {
          // width: 43px;
          height: 100%;
          border-radius: 8px 8px 8px 8px;
          color: #999999;
          padding: 3px 7px;
          font-size: 14px;
          box-sizing: border-box;
          &:nth-child(1) {
            margin-right: 4px;
          }
        }
        .switchBackground {
          background: #064FAF;
          color: #ffffff;
        }
      }
    }
    .search {
      cursor: pointer;
      width: 82px;
      height: 36px;
      background: #064FAF;
      border-radius: 6px 6px 6px 6px;
      display: flex;
      justify-content: center;
      align-items: center;

      font-weight: 500;
      font-size: 16px;
      color: #fff;
      i {
        font-size: 18px;
        margin-right: 6px;
      }
    }
  
    // 日期选择器
    :deep(.el-date-editor) {
      width: 200px !important;
      border: 0px;
      background: #f9f9f9;
      padding: 0;
      display: flex !important;
      align-items: baseline;
      height: 20px;
      .el-range-input{
        padding-left: 4px;
        text-align: left;
      }
      input {
        background: #f9f9f9;
      }
      i.el-input__icon.el-range__icon.null {
        width: 0px;
      }
      .el-date-editor .el-range-separator {
        height: 20px;
      }
    }
  }
  .delivery-main-1 {
    flex-wrap: wrap;
    padding-bottom: 0;
    .delivery-main-box {
      margin-bottom: 16px;
      &:nth-child(n + 1) {
        width: 360px;
      }
      // &:nth-child(n + 2) {
      //   margin-left: 8px;
      // }
      &:nth-child(3n) {
        border: 0;
      }
      &:nth-child(4) {
        border-right: 1px solid #ddd;
        margin-left: 0px;
      }
    }
  }
  
  .youjiantou {
    position: relative;
    .youbian {
      position: absolute;
      // left: 316px;
      top: 18px;
      right: -18px;
    }
    .youbianvv {
      top: 13px;
    }
  }
  
  .jiantou {
    margin-right: 10px;
  }
  
  .delivery-show{
    background: #fff;
    border-radius: 0px 12px 12px 12px;
    padding: 32px 32px 24px 32px;
    box-sizing: border-box;
    box-shadow: 0px 2px 31px 0px rgba(12,48,88,0.08);
  }
  .delivery-foot {
    margin-top: 24px;
    margin-bottom: 24px;
    .jilu {
      width: 80px;
      height: 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #1E406D;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 6px;
      display: block;
    }
    .delivery-history-box {
      .delivery-history {
        // 鼠标样式
        cursor: pointer;
        background: #f5f6f7;
        border-radius: 4px 4px 4px 4px;
        padding: 8px 18px;
  
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #424F62;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-right: 8px;
        margin-bottom: 8px;
      }
    }
  }
  
  .el-dropdown {
    position: relative;
    span {
      position: absolute;
      top: 12px;
      right: 20px;
    }
  }
  // 下拉港口
  .noDate {
    padding: 20px;
    color: #666;
  }
  .el-dropdown-menu {
    :deep(.el-tabs__nav is-top) {
      font-size: 16px !important;
    }
    .el-tabs {
      padding: 0 20px;
      width: 500px;
      .xianDiv {
        padding: 10px;
        color: #666;
        font-size: 14px;
        width: 160px;
        text-align: left;
        display: inline-block;
      }
      .xianDiv:hover {
        color: #0073f5;
      }
    }
  }
  .el-dropdown-menu__item {
    font-size: 16px;
  }
  .el-dropdown-menu {
    // width: 720px;
    // height: 240px;
    background: #fff;
    // position: absolute;
    // top: 0;
    // left: 10px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 12px 12px 12px 12px;
    // // padding: 24px 0;
    // box-sizing: border-box;
    // // 显示滚动条
    overflow-y: auto;
    overflow-x: hidden;
  
    // cursor: pointer;
    .dropdown {
      .dropdown-header-box {
        width: 720px;
        border-bottom: 1px solid #eee;
        padding: 0 24px;
        box-sizing: border-box;
        // padding-bottom: 17px;
  
        .dropdown-header {
          margin-right: 32px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #999999;
          line-height: 19px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
  
      .dropdown-main,
      .dropdown-main-title {
        display: block;
      }
  
      .dropdown-main {
        padding: 24px;
        .dropdown-main-title {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
  
          border-left: 2px solid #0073f5;
          padding-left: 8px;
        }
        .dropdown-main-content {
          margin-top: 16px;
  
          .dropdown-main-content-box {
            width: 162px;
            padding: 8px 24px 8px 12px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #666666;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            box-sizing: border-box;
  
            // 超出隐藏
            overflow: hidden; /* 隐藏超出部分 */
            white-space: nowrap; /* 不换行 */
            text-overflow: ellipsis; /* 超出部分显示为省略号 */
          }
        }
      }
      .dropdown-main-2 {
        padding-top: 0;
      }
    }
  }
  // 下拉港口点击样式
  .dropdownTitle {
    color: #0073f5 !important;
    border-bottom: 2px solid #0073f5;
    padding-bottom: 16px;
  }
  // 选择具体地区样式
  .dropdownContent {
    color: #0073f5 !important;
    border: 1px solid #0073f5;
    background: #edf6ff;
  }
  
  // 导航点击样式
  .border-bottom {
    border-bottom: 4px solid #fff;
    border-radius: 2px 2px 0px 0px;
    padding-bottom: 8px;
  }
  
  .spanA {
    color: #0073f5 !important;
  }
  
  .border-bottomA {
    border-bottom: 4px solid #0073f5;
    border-radius: 2px 2px 0px 0px;
    padding-bottom: 8px;
  }
  // 送货点击样式

  // 导航栏展示样式
  .showList {
    color: #0073f5 !important;
    background: #edf6ff;
  }
  
  .mudig{
    padding: 10px 20px 20px 20px;
    box-sizing: border-box;
    width: 500px;
    .mdglist{
      :deep(.el-select-group){
        display: flex;
        flex-wrap: wrap;
      }
    }
    :deep(.el-select){
      ul.el-select-group{
        display: flex;
      }
    }
  }
  
  .xiangxing{
    :deep(.el-select__tags){
      margin-top: 10px;
      span.el-tag.el-tag--info.el-tag--small.el-tag--light{
            margin: 2px 6px 2px 0;
      }
    }
  }
  </style>